import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Widget from './Widget';
import * as serviceWorker from './serviceWorker';

console.log('Version widget - 1.0.29')

ReactDOM.render(
  <React.StrictMode>
    <Widget />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
